
const lastUpdate = '2026-05-27';
export const helpTitle = 'Layer Drawer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Layer Drawer lets you control which map layers are visible. Browse available layers, toggle visibility, adjust opacity, and save your layer configuration as a preset.</p>

<h2>Browsing Layers</h2>
<ul>
  <li>Layers are organized by category — expand a category to see its layers.</li>
  <li>Use the <strong>Search</strong> box to find a layer by name.</li>
  <li>Click the toggle next to a layer to turn it on or off.</li>
</ul>

<h2>Active Layers Tab</h2>
<p>The <strong>Active</strong> tab shows only the layers currently visible on the map. From here you can:</p>
<ul>
  <li>Adjust a layer's <strong>opacity</strong> using its slider.</li>
  <li>Reorder layers by dragging.</li>
  <li>Remove a layer quickly without hunting through the full list.</li>
  <li>When you turn a layer off it greys out and stays for 5 seconds (with a countdown ring).</li>
</ul>

<h2>Layer Presets</h2>
<ul>
  <li><strong>Save Preset</strong> — Saves your current layer configuration under a name.</li>
  <li><strong>Load Preset</strong> — Restores a previously saved configuration.</li>
</ul>
<p>Presets are useful for switching between common operational views (e.g., fire weather vs. fire locations).</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
